import { makeStyles } from 'onyx-common/styles'

export default makeStyles
